// @flow
import React from 'react';
import PropTypes from 'prop-types';
import {Grid, Modal, Paper, Typography} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import CustomButton from '../../../../elements/CustomButton/CustomButton';

type Props = {|
  open: boolean,
  openModalDelete?: boolean,
  handleClose: () => void,
  handleDeleteClick: () => void,
  isDeleting?: boolean,
|};

const useStyles = makeStyles(theme => ({
  root: {
    display: 'grid',
    justifyItems: 'center',
    alignItems: 'center',
  },
  paper: {
    width: 320,
    height: 280,
    textAlign: 'center',
    padding: theme.spacing(4),
  },
  buttonContainer: {
    marginTop: theme.spacing(2),
  },
  deleteButton: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.error.dark,
    },
    '&:disabled': {
      backgroundColor: theme.palette.error.light,
    },
  },
}));

export default function DeleteConfirmationModal(props: Props) {
  const {open, handleClose, handleDeleteClick, isDeleting} = props;
  const classes = useStyles();

  return (
    <Modal
      open={open || isDeleting}
      className={classes.root}
      disableEscapeKeyDown={true}
      disableBackdropClick={true}
    >
      <Paper className={classes.paper}>
        <Typography gutterBottom variant="h6">
          ¿Seguro que quieres eliminar este método de pago?
        </Typography>
        <Typography gutterBottom variant="subtitle1">
          Si eliminas el método de pago no lo podrás recuperar.
        </Typography>
        <Grid container className={classes.buttonContainer}>
          <Grid item xs={6}>
            <CustomButton
              variant="contained"
              disabled={isDeleting}
              onClick={handleClose}
            >
              Cancelar
            </CustomButton>
          </Grid>
          <Grid item xs={6}>
            <CustomButton
              variant="contained"
              onClick={handleDeleteClick}
              className={classes.deleteButton}
              disabled={isDeleting}
            >
              Eliminar
            </CustomButton>
          </Grid>
        </Grid>
      </Paper>
    </Modal>
  );
}

DeleteConfirmationModal.propTypes = {
  open: PropTypes.bool.isRequired,
  openModalDelete: PropTypes.bool,
  handleClose: PropTypes.func.isRequired,
  handleDeleteClick: PropTypes.func.isRequired,
  isDeleting: PropTypes.bool,
};
